import React from "react";
import Table from "react-bootstrap/Table";
import MetricFormatter from "dashboards/MetricFormatter";

class KeywordTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortBy: props.keyword_sort,
      sortOrderAsc: props.keyword_sort_order_asc,
      sortedKeywords: [],
    };
  }

  sortKeywords(by, initial = false) {
    let kwCopy = this.props.keywords === null ? [...this.state.sortedKeywords] : initial ? this.props.keywords : [...this.state.sortedKeywords];
    let tempSortOrder = this.state.sortOrderAsc;
    if (by == this.state.sortBy && !initial) {
      tempSortOrder = !tempSortOrder;
      kwCopy.reverse();
    } else {
      tempSortOrder = initial ? this.state.sortOrderAsc : true;
      if (by == "keyword") {
        kwCopy.sort((a, b) => {
          if (a.keyword.toLowerCase() < b.keyword.toLowerCase()) return -1;
          if (a.keyword.toLowerCase() > b.keyword.toLowerCase()) return 1;
          return 0;
        });
      } else if (by == "prevpos") {
        kwCopy.sort((a, b) => {
          if (typeof a.start_date_ranking == "string") a.start_date_ranking = parseFloat(a.start_date_ranking);
          if (typeof b.start_date_ranking == "string") b.start_date_ranking = parseFloat(b.start_date_ranking);

          if (a.start_date_ranking == 0) return 1;
          if (b.start_date_ranking == 0) return -1;
          if (a.start_date_ranking < b.start_date_ranking) return -1;
          if (a.start_date_ranking > b.start_date_ranking) return 1;
          return 0;
        });
      } else if (by == "currentpos") {
        kwCopy.sort((a, b) => {
          if (a.end_date_ranking == 0) return 1;
          if (b.end_date_ranking == 0) return -1;
          if (a.end_date_ranking < b.end_date_ranking) return -1;
          if (a.end_date_ranking > b.end_date_ranking) return 1;
          return 0;
        });
      } else if (by == "diff") {
        kwCopy.sort((a, b) => {
          if (a.ranking_difference < b.ranking_difference) return -1;
          if (a.ranking_difference > b.ranking_difference) return 1;
          return 0;
        });
      } else if (by == "cpc") {
        kwCopy.sort((a, b) => {
          if (isNaN(parseFloat(a.cpc))) return -1;
          if (isNaN(parseFloat(b.cpc))) return 1;
          if (parseFloat(a.cpc) < parseFloat(b.cpc)) return -1;
          if (parseFloat(a.cpc) > parseFloat(b.cpc)) return 1;
          return 0;
        });
      } else if (by == "volume") {
        kwCopy.sort((a, b) => {
          if (isNaN(parseFloat(a.volume))) return -1;
          if (isNaN(parseFloat(b.volume))) return 1;
          if (parseFloat(a.volume) < parseFloat(b.volume)) return -1;
          if (parseFloat(a.volume) > parseFloat(b.volume)) return 1;
          return 0;
        });
      } else if (by == "difficulty") {
        kwCopy.sort((a, b) => {
          if (isNaN(parseFloat(a.difficulty))) return -1;
          if (isNaN(parseFloat(b.difficulty))) return 1;
          if (parseFloat(a.difficulty) < parseFloat(b.difficulty)) return -1;
          if (parseFloat(a.difficulty) > parseFloat(b.difficulty)) return 1;
          return 0;
        });
      }
      if (!tempSortOrder) {
        kwCopy.reverse();
      }
    }

    this.setState({ sortBy: by, sortOrderAsc: tempSortOrder, sortedKeywords: kwCopy });
  }
  componentDidMount() {
    this.setState({ sortedKeywords: this.props.keywords });
    this.sortKeywords(this.state.sortBy, true);
  }
  render() {
    const sortUpHtml = <i className="fas fa-sort-up"></i>;
    const sortDownHtml = <i className="fas fa-sort-down"></i>;
    return (
      <div>
        <div>
          {!this.props.pdf && this.props.user_is_employee && (
            <form style={{ float: "right" }}>
              <input hidden value={this.state.sortBy} name="keyword_sort" readOnly />
              <input hidden value={this.state.sortOrderAsc} name="keyword_sort_order_asc" readOnly />
              <button type="submit" className="btn btn-info height-min-content mx-4">
                Apply Sort to PDF
              </button>
            </form>
          )}
        </div>
        <div className="mb-2 keyword-ranking-table table-responsive">
          <Table striped className="mt-2 table-white">
            <thead>
              <tr>
                {this.props.metrics["metrics_data"]["keywordName"] == "1" && (
                  <th onClick={(e) => this.sortKeywords("keyword")}>
                    Keyword&nbsp;
                    {this.state.sortBy == "keyword" ? this.state.sortOrderAsc ? sortUpHtml : sortDownHtml : <></>}
                  </th>
                )}
                {this.props.metrics["metrics_data"]["keywordSerpFeatures"] == "1" && <th className="nosort">SERP Features</th>}
                {this.props.metrics["metrics_data"]["keywordPreviousPosition"] == "1" && (
                  <th onClick={(e) => this.sortKeywords("prevpos")}>
                    Prev. Pos&nbsp;
                    {this.state.sortBy == "prevpos" ? this.state.sortOrderAsc ? sortUpHtml : sortDownHtml : <></>}
                  </th>
                )}
                {this.props.metrics["metrics_data"]["keywordCurrentPosition"] == "1" && (
                  <th onClick={(e) => this.sortKeywords("currentpos")}>
                    Current Pos&nbsp;
                    {this.state.sortBy == "currentpos" ? this.state.sortOrderAsc ? sortUpHtml : sortDownHtml : <></>}
                  </th>
                )}
                {this.props.metrics["metrics_data"]["keywordDifference"] == "1" && (
                  <th onClick={(e) => this.sortKeywords("diff")}>
                    Diff&nbsp;
                    {this.state.sortBy == "diff" ? this.state.sortOrderAsc ? sortUpHtml : sortDownHtml : <></>}
                  </th>
                )}
                {this.props.metrics["metrics_data"]["keywordCostPerConversion"] == "1" && (
                  <th onClick={(e) => this.sortKeywords("cpc")}>
                    CPC&nbsp;
                    {this.state.sortBy == "cpc" ? this.state.sortOrderAsc ? sortUpHtml : sortDownHtml : <></>}
                  </th>
                )}
                {this.props.metrics["metrics_data"]["keywordSearchVolume"] == "1" && (
                  <th onClick={(e) => this.sortKeywords("volume")}>
                    Volume&nbsp;
                    {this.state.sortBy == "volume" ? this.state.sortOrderAsc ? sortUpHtml : sortDownHtml : <></>}
                  </th>
                )}

                {this.props.metrics["metrics_data"]["keywordDifficulty"] == "1" && (
                  <th onClick={(e) => this.sortKeywords("difficulty")}>
                    Difficulty&nbsp;
                    {this.state.sortBy == "difficulty" ? this.state.sortOrderAsc ? sortUpHtml : sortDownHtml : <></>}
                  </th>
                )}

                {this.props.metrics["metrics_data"]["keywordLabel"] == "1" && <th className="nosort"> Label</th>}
                {this.props.metrics["metrics_data"]["keywordUrl"] == "1" && <th className="nosort rankingPage">Ranking Page</th>}
              </tr>
            </thead>
            <tbody>
              {this.state.sortedKeywords.map((keyword, i) => {
                let diffBackground = "";
                if (keyword.ranking_difference > 0) diffBackground = "bg-success text-white";
                else if (keyword.ranking_difference < 0) diffBackground = "bg-danger text-white";
                return (
                  <tr key={keyword.keyword + i}>
                    {this.props.metrics["metrics_data"]["keywordName"] == "1" && (
                      <td>
                        <div className="keyword-table-row">{keyword.keyword}</div>
                      </td>
                    )}
                    {this.props.metrics["metrics_data"]["keywordSerpFeatures"] == "1" && (
                      <td>
                        <div className="keyword-table-row">
                          {keyword.serp_features.map((serp_feature) => {
                            if (serp_feature == "rel") return <i key={serp_feature} className="fas fa-question"></i>;
                            if (serp_feature == "rev") return <i key={serp_feature} className="fas fa-star"></i>;
                            if (serp_feature == "fsn") return <i key={serp_feature} className="fas fa-crown"></i>;
                            if (serp_feature == "shp") return <i key={serp_feature} className="fas fa-shopping-cart"></i>;
                            if (serp_feature == "stl") return <i key={serp_feature} className="fas fa-link"></i>;
                            if (serp_feature == "adt") return <i key={serp_feature} className="fas fa-ad"></i>;
                            if (serp_feature == "adb") return <i key={serp_feature} className="fas fa-ad"></i>;
                            if (serp_feature == "vid") return <i key={serp_feature} className="fab fa-youtube"></i>;
                            if (serp_feature == "img") return <i key={serp_feature} className="far fa-images"></i>;
                            if (serp_feature == "geo") return <i key={serp_feature} className="fas fa-globe"></i>;
                            if (serp_feature == "vib") return <i key={serp_feature} className="fas fa-video"></i>;
                            if (serp_feature == "new") return <i key={serp_feature} className="fas fa-newspaper"></i>;
                            if (serp_feature == "twt") return <i key={serp_feature} className="fab fa-twitter-square"></i>;
                            if (serp_feature == "knw") return <i key={serp_feature} className="fas fa-bolt"></i>;
                            if (serp_feature == "kng") return <i key={serp_feature} className="far fa-circle"></i>;
                          })}
                        </div>
                      </td>
                    )}
                    {this.props.metrics["metrics_data"]["keywordPreviousPosition"] == "1" && (
                      <td>
                        <div className="keyword-table-row">
                          {keyword.start_date_ranking == 0 ? "100+" : <MetricFormatter.Sessions value={keyword.start_date_ranking} />}
                        </div>
                      </td>
                    )}
                    {this.props.metrics["metrics_data"]["keywordCurrentPosition"] == "1" && (
                      <td>
                        <div className="keyword-table-row">
                          {keyword.end_date_ranking == 0 ? "100+" : <MetricFormatter.Sessions value={keyword.end_date_ranking} />}
                        </div>
                      </td>
                    )}
                    {this.props.metrics["metrics_data"]["keywordDifference"] == "1" && (
                      <td className={diffBackground}>
                        <div className="keyword-table-row">
                          <MetricFormatter.Sessions value={keyword.ranking_difference} />
                        </div>
                      </td>
                    )}
                    {this.props.metrics["metrics_data"]["keywordCostPerConversion"] == "1" && (
                      <td>
                        <div className="keyword-table-row">
                          <MetricFormatter.CPC value={isNaN(parseFloat(keyword.cpc)) ? 0 : parseFloat(keyword.cpc)} />
                        </div>
                      </td>
                    )}
                    {this.props.metrics["metrics_data"]["keywordSearchVolume"] == "1" && (
                      <td>
                        <div className="keyword-table-row">
                          <MetricFormatter.Sessions value={isNaN(parseFloat(keyword.volume)) ? 0 : parseFloat(keyword.volume)} />
                        </div>
                      </td>
                    )}
                    {this.props.metrics["metrics_data"]["keywordDifficulty"] == "1" && (
                      <td>
                        <div className="keyword-table-row">
                          <MetricFormatter.Sessions value={isNaN(parseFloat(keyword.difficulty)) ? 0 : parseFloat(keyword.difficulty)} />
                        </div>
                      </td>
                    )}
                    {this.props.metrics["metrics_data"]["keywordLabel"] == "1" && (
                      <td>
                        <div className="keyword-table-row">
                          {keyword.tag &&
                            keyword.tag.map((el, index) => {
                              let string = el;
                              if (index < keyword.tag.length - 1) string += ", ";
                              return string;
                            })}
                        </div>
                      </td>
                    )}
                    {this.props.metrics["metrics_data"]["keywordUrl"] == "1" && (
                      <td style={{ fontSize: "0.8rem" }}>
                        <div className="keyword-table-row rankingPage">{keyword.ranking_page}</div>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

export default KeywordTable;
